<template>
  <div>
    <span class="text-uppercase field-label">Owner</span>
    <!-- <div class="info-bubbles">
      <span
        v-b-tooltip.hover.html
        :title="(index < 3) ? fieldValue.name : getTitle(deliverable.users)"
        class="initials badge badge-primary"
        v-for="(fieldValue, index) in groupedUser"
        :key="'fieldValue'+index"
        v-if="index<=3"
      >
        <span class="exclude-outside-click" v-if="index<3">{{fieldValue.name | textInitials}}</span>
        <span class="exclude-outside-click" v-if="index==3">+{{ deliverable.users.length-index }}</span>
      </span>
    </div>-->
    <div class="lead-coordinator cursor-pointer" @click="showChangeCoordinator">
      <span class="info-bubbles">
        <span
          v-if="deliverable.lead_coordinator"
          v-b-tooltip.hover.html
          :title="deliverable.lead_coordinator.name"
          class="initials badge"
          :class="getColorClass()"
        >
          <span class="exclude-outside-click">{{deliverable.lead_coordinator.name | textInitials}}</span>
        </span>
        <span
          v-else
          v-b-tooltip.hover.html
          :title="deliverable.tasks[0].taskFields[0].userName"
          class="initials badge badge-primary"
        >
          <span
            class="exclude-outside-click"
          >{{deliverable.tasks[0].taskFields[0].userName | textInitials}}</span>
        </span>
      </span>
      <div class="add-multiselect-group">
        <plus-button></plus-button>
        <div class="custom-field user-field custom-multiselect" v-show="changeCoordinatorFlag">
          <multiselect
            ref="deliverableListCoordinators"
            v-click-outside="outside"
            v-model="deliverable.lead_coordinator"
            :options="groupedUser"
            :show-labels="true"
            :multiple="false"
            :allow-empty="false"
            open-direction="bottom"
            label="name"
            track-by="id"
            @close="changeCoordinatorFlag=false"
            @input="changeLeadCoordinator(deliverable); changeCoordinatorFlag = false"
          ></multiselect>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import router from "../../routes";
export default {
  props: ["deliverable"],
  data() {
    return {
      changeCoordinatorFlag: false
    };
  },
  computed: {
    ...mapGetters(['userAbilities']),
    groupedUser() {
      let result = {};
      let users = this.deliverable.users;
      if(this.deliverable.lead_coordinator != null) {
        users.push(this.deliverable.lead_coordinator);
      }
      result = users.filter(
        (user, index, self) =>
          index ===
          self.findIndex(t => t.id === user.id && t.name === user.name)
      );
      return result;
    }
  },
  methods: {
    ...mapActions(["updateFieldValue", "changeLeadCoordinator"]),
    getTitle(contacts) {
      let title = "";
      contacts.forEach((contact, index) => {
        if (index >= 3) {
          title += contact.name + "<br>";
        }
        return title;
      });
      return title;
    },
    outside() {
      this.$set(this, "changeCoordinatorFlag", false);
    },
    getColorClass() {
      if (router.currentRoute.name == "myWeek") {
        return this.deliverable.lead_coordinator.id ==
          localStorage.getItem("userId")
          ? "badge-primary"
          : "other-user-badge";
      } else {
        return "badge-primary";
      }
    },
    showChangeCoordinator() {
      if(!this.userAbilities.editMediaCall || this.deliverable.permissions.viewOnly) return;
      this.changeCoordinatorFlag = true;
      this.$nextTick(() => {
        this.$refs.deliverableListCoordinators.$el.focus();
      });
    }
  }
};
</script>

<style>
</style>